import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { RewardsEarningRulesEntity } from "../models/RewardsEarningRulesEntities";

export interface RewardsEarningRulesState {
    earningRulesList: RewardsEarningRulesEntity[];
}

const createInitialState = (): RewardsEarningRulesState => ({
    earningRulesList: [],
});

@singleton()
@StoreConfig({ name: "RewardsEarningRulesStore" })
class RewardsEarningRulesStore extends BaseStore<RewardsEarningRulesState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsEarningRulesStore;
